$ = jQuery;
$(document).ready(function () {

    //Initialize bootstrap tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl, {
            trigger: 'hover'
        });
    });
})

class configurator {


    constructor() {
        this.initiating = true;
    }

    async init() {
        this.one_time_events_done = false;
        this.max_dialog_size = 500;
        this.gasspring_index_previous = -1;

        /*
        Populate mounting part and gas spring selects
         */
        this.initiate_drop_downs();
        this.as = new auto_select();
        this.cookie = new cookie();
        this.save = new save(this.cookie);
        this.set_cookie_values_to_html();
        this.force_alarm;
        this.drop_down_gs.fill_html_select();
        this.drop_down_rod.fill_html_select();
        this.drop_down_cyl.fill_html_select();
        this.set_listeners();

        this.initiating = false;
        await this.update();
    }

    set_cookie_values_to_html() {
        /*
        Set the cookie values if there are cookies
         */
        this.cookie.set_cookie_values_to_html();

        /*
        Run the gas spring change function to set some things straight
         */
        this.change_gasspring(false);

        //if we come from and old configuration link, we need to put the cookie data to the form
        if(this.cookie.old_configuration_link_used) {
            var cookie_data = this.cookie.get();
            fd.set_cookie_data_to_form(cookie_data);
        }

        var form_data = fd.get();

        /*
        Set the pics right in step 1
         */
        this.set_mounting_part_images("mp_cyl_type", form_data.mp_cyl_type);
        this.set_mounting_part_images("mp_rod_type", form_data.mp_rod_type);
        this.set_cut_off_img();

        /*
        Set the right mounting part as selected in the mounting part chooser dialog
         */
        this.set_mounting_part_dialog_image_selected("mp_cyl_type", form_data.mp_cyl_type);
        this.set_mounting_part_dialog_image_selected("mp_rod_type", form_data.mp_rod_type);



        /*
        Set the cookie values again because force list was just populated
         */
        this.cookie.set_cookie_values_to_html();

    }

    initiate_drop_downs() {
        this.drop_down_cyl = new drop_down_mp("mp_cyl", "mp_li_template");
        this.drop_down_rod = new drop_down_mp("mp_rod", "mp_li_template");
        this.drop_down_gs = new drop_down_gs("gasspring", "gasspring_li_template");
    }

    /*
    This update is done like this in two steps because otherwise the loader will not popup. This
    because the DOM is updated after the javascript.
     */
    async update(do_plot = true) {
        if (this.initiating) {
            return;
        }

        // const err = new Error();
        // const stack = err.stack; //.split('\n');
        // console.log(stack); // This should show the caller function

        var loader = $('.cf_loader');
        loader.show();
        await this.update_this(do_plot);
        this.set_alarms();
        loader.hide();

        // console.log(
        //     $('#length_deviation_warning').css('display'),
        //     $('#force_deviation_warning').css('display')
        // );
        if ($('#length_deviation_warning').css('display') !== 'none' || $('#force_deviation_warning').css('display') !== 'none') {
            $('#deviation_container')
                .show()
                .css({
                    'border': '1px solid #307bfb',         // Add a border
                    'background-color': '#dff0ff'      // Add a background color
                });
        } else {
            $('#deviation_container').hide();
        }
    }

    async update_this(do_plot) {
        try {
            // start();
            $('.cf-selector').removeClass('selector-staal').removeClass('selector-rvs').removeClass('selector-rvs316').addClass('selector-' + fd.get().material);

            // check if all material options are allowed
            this.change_type();


            if (this.as.auto_select) {
                // console.log("auto selecting")
                this.as.auto_select = false;
                this.as.length_combi_index = 0;
                await this.as.calculate_length_combis();
                await this.as.set_length_combi();
            } else {
                if (cf.as.sorted_length_combis.length) {
                    // if not using auto select on server, we can still find the best mounting parts for this gas spring from the previous results
                    this.as.length_combi_index = this.as.gs_desc_list.indexOf(fd.get().gasspring);
                    if (this.as.length_combi_index !== -1 && this.gasspring_index_previous !== this.gasspring_index && this.gasspring_index_previous !== -1 ) {
                        await this.as.set_length_combi();
                    }
                } else {
                    if (fd.get().step_visited === 'step-2') {
                        // on startup
                        this.as.length_combi_index = 0;
                        // no await such that it does not slow down page loading
                        await this.as.calculate_length_combis();
                    }
                }
            }
            
            this.update_unit_system_visibility();
            this.drop_down_gs.update_visibility();
            this.drop_down_cyl.update_visibility();
            this.drop_down_rod.update_visibility();

            var mp_cyl_index = $('#mp_cyl :selected').data('i') ?? 0;
            var mp_rod_index = $('#mp_rod :selected').data('i') ?? 0;

            this.mp_cyl = mp_data[mp_cyl_index];
            this.mp_rod = mp_data[mp_rod_index];

            this.manage_3d_buttons();
            this.manage_2d_buttons();

            this.manage_materials();
            this.manage_types();

            this.gasspring_set = new gasspring_set(this.gs, this.mp_cyl, this.mp_rod);
            if (!this.one_time_events_done) {
                this.plot_3d = new plot_3d(this);
                this.one_time_events_done = true;
            }

            this.set_price_text();
            this.set_configurator_description();

            this.canvas_visible = !$("#step-2").hasClass('hidden');
            if (this.initiating) {
                this.as.length_combi_index = 0;
                await this.as.calculate_length_combis();
                await this.as.set_length_combi();
            } else {
                if (do_plot && this.canvas_visible) {
                    await this.plot_3d.plot_configuration_2d();
                }
            }

            if (!this.initiating) {
                this.cookie.set();
            }

            this.cookie_old = JSON.stringify($('#cf-form').serializeAll());
            this.gasspring_index_previous = this.gasspring_index;

            this.set_length_warning();

        } catch (e) {
            console.log(e);
            const d = new dialog('<div>' + 'An error occurred, trying to recover with previous input' + '</div>', 500, 500);
            d.open();

            this.cookie.set(this.cookie_old);
            this.set_cookie_values_to_html();
        }
    }

    get_products_without_glb() {
        var products = [];
        for (let mp of mp_data) {
            if (mp.glb === '' && mp.hahntype !== 'none') {
                products.push([mp.hahntype])
            }
        }

        for (let gs of gs_data) {
            if (gs.glb === '') {
                products.push([this.get_gs_description(gs)]);
            }
        }

        if (products.length) {
            const csvContent = "data:text/csv;charset=utf-8," + products.map(row => row.join(',')).join('\n');

            // Create a download link and trigger a click to download the file
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'missing_step_files.csv');
            document.body.appendChild(link);
            link.click();
        }
    }

    set_length_warning() {
        var wished_gs_length = gid('gasspring_total_length').value * 1;
        var total_length = cf.mp_rod.elongationlength * 1 + cf.mp_cyl.elongationlength * 1 + cf.gs.lengte * 1;
        var non_abs_error = total_length - gid('gasspring_total_length').value * 1;
        var l_tot_text_diff = "";
        var actual_length;
        var length_deviation_text = "";
        var wished_gs_length_inc_unit = "";
        var unit = "mm";
        if (gid("units").value === "Imperial") {
            l_tot_text_diff = (mm_to_inch(non_abs_error) < 0 ? "" : "+") + mm_to_inch(non_abs_error) + "\"";;
            wished_gs_length_inc_unit = mm_to_inch(wished_gs_length) + "\"";
            actual_length = mm_to_inch(total_length) + "\"";
            unit = "\"";
        } else {
            l_tot_text_diff =  (non_abs_error < 0 ? "" : "+") + non_abs_error + "mm";
            wished_gs_length_inc_unit = wished_gs_length + "mm";
            actual_length = total_length + "mm";
        }

        $('#length_deviation_warning').hide();
        $('#length_deviation_warning').html('');

        if (non_abs_error !== 0) {
            length_deviation_text = cf.formatString(
                texts.length_deviation,
                wished_gs_length_inc_unit,
                l_tot_text_diff
            );


            // set a warning if the length deviates from the chosen length
            if ((fd.get().mp_cyl_type !== 'none' || fd.get().mp_rod_type !== 'none')) {
                if (fd.get().gasspring_total_length !== '') {
                    $('#length_deviation_warning').show(); // Makes the element visible
                    $('#length_deviation_warning').html(
                        $('<span>', {
                            text: length_deviation_text,
                        })
                    );
                }
            }
        }
    }

    showAlarmPopup(alarmText) {
        var modal = document.getElementById('alarm-modal');
        $('#alarmmodaltext').html(alarmText);
        modal.style.display = 'block';
    }

    set_alarms() {
        let alarmText = '';
        let wished_force = $('input[name="gasspring_wished_force"]').val() * 1;

        let maxforceallowedhuis = this.mp_cyl.maxforceallowed * 1;
        let maxforceallowedstang = this.mp_rod.maxforceallowed * 1;

        if (maxforceallowedhuis !== undefined && maxforceallowedhuis !== 0 && maxforceallowedhuis !== "") {
            if (maxforceallowedhuis < wished_force * 1) {
                alarmText += texts.huiskrachttegroottext;
            }
        }
        if (maxforceallowedstang !== undefined && maxforceallowedstang !== 0 && maxforceallowedstang !== "") {
            if (maxforceallowedstang < wished_force * 1) {
                alarmText += texts.stangkrachttegroottext;
            }
        }

        if(alarmText !== "") {
            alarmText = '<h2 id="alarm-modal-header">' + texts.attention + '</h2><br>' + alarmText;
            this.showAlarmPopup(alarmText);
        }
    }

    manage_materials() {
        if (materials_available.length === 1) {
            $('#material_container').hide();
        }
    }

    manage_types() {
        if (types_available.length === 1) {
            $('#type_container').hide();
        }
    }

    manage_3d_buttons() {
        var mp_cyl_button = $('button.show_3d_cad[data-what="mp_cyl"]');
        this.mp_cyl.glb_array.length === 0 ? mp_cyl_button.prop("disabled", true) : mp_cyl_button.prop("disabled", false);

        var mp_rod_button = $('button.show_3d_cad[data-what="mp_rod"]');
        this.mp_rod.glb_array.length === 0 ? mp_rod_button.prop("disabled", true) : mp_rod_button.prop("disabled", false);

        var gs_button = $('button.show_3d_cad[data-what="gs"]');
        this.gs.glb === '' ? gs_button.prop("disabled", true) : gs_button.prop("disabled", false);
    }

    manage_2d_buttons() {
        var mp_cyl_button = $('button.show_2d_cad[data-what="mp_cyl"]');
        this.mp_cyl.cad_array.length === 0 ? mp_cyl_button.prop("disabled", true) : mp_cyl_button.prop("disabled", false);

        var mp_rod_button = $('button.show_2d_cad[data-what="mp_rod"]');
        this.mp_rod.cad_array.length === 0 ? mp_rod_button.prop("disabled", true) : mp_rod_button.prop("disabled", false);
    }

    sync_metric_imperial() {

        if ($('#units').val() === 'Metric') {
            // convert imperial to metric
            $("#gasspring_total_length").val(inch_to_mm($("#gasspring_total_length_imperial").val()));
            $('#gasspring_wished_force').val(lbs_to_newton($('#gasspring_wished_force_imperial').val()));
            $('#gasspring_total_length').css('width', '80px');
            $('#label-metric').css('padding-right', '90px');

        } else {
            // convert metric to imperial
            $("#gasspring_total_length_imperial").val(mm_to_inch($("#gasspring_total_length").val()));
            $('#gasspring_wished_force_imperial').val(newton_to_lbs($('#gasspring_wished_force').val()));
            $('#gasspring_total_length_imperial').css('width', '75px');
            $('#label-metric').css('padding-right', '90px');
        }
    }

    //if switch_layout is true, there will be a layout change
    //else only the value will be converted
    sync_metric_to_imperial(switch_layout = false) {

        // convert metric to imperial
        $("#gasspring_total_length_imperial").val(mm_to_inch($("#gasspring_total_length").val()));
        $('#gasspring_wished_force_imperial').val(newton_to_lbs($('#gasspring_wished_force').val()));

        if (switch_layout) {
            $('#gasspring_total_length_imperial').css('width', '75px');
            $('#label-metric').css('padding-right', '90px');
        }
    }

    //if switch_layout is true, there will be a layout change
    //else only the value will be converted
    sync_imperial_to_metric(switch_layout = false) {

        // convert imperial to metric
        $("#gasspring_total_length").val(inch_to_mm($("#gasspring_total_length_imperial").val()));
        $('#gasspring_wished_force').val(lbs_to_newton($('#gasspring_wished_force_imperial').val()));

        if (switch_layout) {
            $('#gasspring_total_length').css('width', '80px');
            $('#label-metric').css('padding-right', '90px');
        }
    }

    update_unit_system_visibility() {
        if (fd.get().units === 'Imperial') {
            $('.metric').hide();
            $('.imperial').show();
            $('.imperial').filter('input').attr('style', 'display: inline-block !important;');
        } else {
            $('.imperial').hide();
            $('.metric').show();
        }
    }

    change_gasspring(update = false) {
        this.gasspring_index = $('#gasspring :selected').data('i') ?? 0;
        this.gs = gs_data[cf.gasspring_index];
        $('#thread').val(this.gs.dschroefdraad);

        if (typeof (this.drop_down_gs.html_select) !== 'undefined') {
            this.drop_down_gs.html_select.sync();
        }

        /*
        Check if selected mounting part type is available
         */
        this.set_gasspring_forces(this.gs);
        var filtered = mp_data_store.do_query(function (item) {
            return ((item.dschroefdraad === fd.get().thread && item.materiaal === fd.get().material) || item.hahntype === 'none');
        }, true);

        if (filtered.type_aanbouwdeel_unique.indexOf(fd.get().mp_cyl_type) === -1) {
            $('#mp_cyl_type_schroefoog').prop('checked', true);
        }
        if (filtered.type_aanbouwdeel_unique.indexOf(fd.get().mp_rod_type) === -1) {
            $('#mp_rod_type_schroefoog').prop('checked', true);
        }

        if (update) {
            this.update();
        }
    }

    set_gasspring_forces(gs) {
        var select = $("#force");
        select[0].options.length = 0;
        var forces = gs.force_array;
        select.append('<option value="none">' + texts.kieswoord + '</option>');
        for (var i = 0; i < forces.length; i++) {
            if (fd.get().units === 'Metric') {
                select.append('<option value="' + forces[i] + '">' + forces[i] + 'N</option>');
            } else {
                select.append('<option value="' + forces[i] + '">' + newton_to_lbs(forces[i]) + ' lbs.</option>');
            }
        }

        $('#force_deviation_warning').hide();
        $('#force_deviation_warning').html('');
        var wished_force = fd.get().gasspring_wished_force * 1;
        if (wished_force) {
            var closest_force = get_closest_array_value(forces, wished_force);

            $('#force').val(closest_force);
            this.force_alarm = false;

            var force_diff = 0;
            var force_diff_string_select = "";
            var force_diff_string_warning = "";
            var wished_force_inc_unit = "";

            if (closest_force !== wished_force) {
                this.force_alarm = true;
                if (fd.get().units === 'Metric') {
                    force_diff = closest_force - wished_force;
                    force_diff_string_select = closest_force + " (" + (force_diff < 0 ? "" : "+") + force_diff + ") N";
                    force_diff_string_warning = (force_diff < 0 ? "" : "+") + force_diff + "N";
                    wished_force_inc_unit = wished_force + 'N';
                } else {
                    force_diff = Math.round((newton_to_lbs(closest_force) - fd.get().gasspring_wished_force_imperial) * 10) / 10;
                    wished_force_inc_unit = newton_to_lbs(wished_force) + 'lbs';
                    force_diff_string_select = newton_to_lbs(closest_force) + " (" + (force_diff < 0 ? "" : "+") + force_diff + ") lbs";
                    force_diff_string_warning = (force_diff < 0 ? "" : "+") + force_diff + "lbs";
                }

                $("#force option[value='" + closest_force + "']").html(force_diff_string_select);

                // set a warning if the force deviates from the chosen force
                //Check for deviation and show the element if necessary
                var force_deviation_text = this.formatString(
                    texts.force_deviation,
                    wished_force_inc_unit,
                    force_diff_string_warning
                );


                $('#force_deviation_warning').show().html(
                    $('<span>', {
                        text: force_deviation_text,
                    })
                );
            }
            $("#force option[value='" + closest_force + "']").css('background-color', '#00be5a').css('font-weight', 'bold').css('color', 'white');
        }
    }

    formatString(template, ...values) {
        return template.replace(/%(\d+)\$s/g, (_, index) => values[parseInt(index) - 1]);
    }

    change_material() {
        if (fd.get().material !== 'staal' && fd.get().type === 'gastrekveer') {
            $('#material').val('staal');
            $('#material').change();
        }

        $('.cf-selector').removeClass('selector-staal').removeClass('selector-rvs').removeClass('selector-rvs316').addClass('selector-' + fd.get().material);

        $('i.fl-icon-question-step-1-middle.fa.fa-question-circle').css('color', 'rgb(157 157 157)');
        if (fd.get().material !== 'staal') {
            $('i.fl-icon-question-step-1-middle.fa.fa-question-circle').css('color', 'black');
        }



        this.set_cut_off_img();
    }

    set_cut_off_img () {
        const cfCutOffImage = document.querySelector('.cf-selector-middle img');
        const mpPopupNoneImage = document.querySelector('.mp-filter-none img');
        const materialValue = document.getElementById("material").value;

        if (materialValue === 'staal') {
            cfCutOffImage.src = '/wp-content/plugins/fl_gasspring_configurator/assets/dist/img/gasspring-cylinder-cut-small.png';
            mpPopupNoneImage.src = '/wp-content/plugins/fl_gasspring_configurator/assets/dist/img/staal_none.jpg';
        } else {
            cfCutOffImage.src = '/wp-content/plugins/fl_gasspring_configurator/assets/dist/img/gasspring-cylinder-rvs-cut-small.png';
            mpPopupNoneImage.src = '/wp-content/plugins/fl_gasspring_configurator/assets/dist/img/rvs_none.jpg';
        }

    }

    change_type() {
        var rvsOption = '<option value="rvs">' + texts.optionrvs304 + '</option>';
        var rvs316Option = '<option value="rvs316">' + texts.optionrvs316 + '</option>';

        // Remove the options 'rvs' and 'rvs316' when type is 'gastrekveer'
        if (fd.get().type === 'gastrekveer') {
            $('#material option[value="rvs"], #material option[value="rvs316"]').remove();
        }

        console.log('Available mats: ' + JSON.stringify(materials_available, null, 2));
        // Add the options 'rvs' and 'rvs316' if type is 'gasveer' and if they are not yet there
        if (fd.get().type === 'gasveer') {
            if ($('#material option[value="rvs"]').length === 0 && materials_available.includes('rvs')) {
                $('#material').append(rvsOption);
            }

            if ($('#material option[value="rvs316"]').length === 0 && materials_available.includes('rvs316')) {
                $('#material').append(rvs316Option);
            }
        }

        if (fd.get().material !== 'staal' && fd.get().type === 'gastrekveer') {
            $('#material').val('staal');
            $('#material').change();

        }
    }

    async add_to_cart() {
        if (fd.get().force === 'none') {
            alert(texts.kieskrachttekst);
            return;
        }
        var loader = $('.cf_loader');
        loader.show();

        var cart_data = {};
        cart_data.security = texts.security;
        cart_data.gasspring = {
            id: this.gs.woo_id,
            force: fd.get().force,
            qty: fd.get().nr_gassprings
        };

        cart_data.mp_cyl = {
            id: this.mp_cyl.woo_id,
            qty: fd.get().nr_gassprings
        };
        cart_data.mp_rod = {
            id: this.mp_rod.woo_id,
            qty: fd.get().nr_gassprings
        };

        cart_data.short_url = await this.save.get_short_url();
        cart_data.action = 'fl_gasspring_configurator';
        cart_data.sub_action = 'add_to_cart';

        var xhr = $.ajax({
            url: texts.ajaxurl,
            data: cart_data,
            type: 'post',
            success: function (results) {
                window.location = texts.cart_url;
            },
            error: function (xhr, status, err) {
                console.log(err);
            }
        });

    }

    set_price_text() {
        var text_html;
        var total_price_without_discount = Math.round(fd.get().nr_gassprings * this.gasspring_set.price * 100) / 100;

        var total_price_discounted = 0;
        var gasveer_price_piece, aanbouw_price_piece_cyl, aanbouw_price_piece_rod;
        if (config_price_ex) {
            gasveer_price_piece = this.gs.price_ex * 1;
            aanbouw_price_piece_cyl = this.mp_cyl.price_ex * 1;
            aanbouw_price_piece_rod = this.mp_rod.price_ex * 1;
        } else {
            gasveer_price_piece = this.gs.price * 1;
            aanbouw_price_piece_cyl = this.mp_cyl.price * 1;
            aanbouw_price_piece_rod = this.mp_rod.price * 1;
        }

        if (fd.get().mp_cyl === fd.get().mp_rod) {
            var nr_mounting_parts = fd.get().nr_gassprings * 2;

            for (var i = 1; i <= Object.keys(volume_discount).length; i++) {
                if (fd.get().nr_gassprings >= volume_discount[i].from * 1 && fd.get().nr_gassprings <= volume_discount[i].to * 1) {
                    gasveer_price_piece = gasveer_price_piece * (1 - volume_discount[i].amount / 100);
                }
                if (nr_mounting_parts >= volume_discount[i].from * 1 && nr_mounting_parts <= volume_discount[i].to * 1) {
                    aanbouw_price_piece_cyl = aanbouw_price_piece_cyl * (1 - volume_discount[i].amount / 100);
                }
            }
            total_price_discounted = fd.get().nr_gassprings * gasveer_price_piece + nr_mounting_parts * aanbouw_price_piece_cyl;
        } else {
            for (var i = 1; i <= Object.keys(volume_discount).length; i++) {
                if (fd.get().nr_gassprings >= volume_discount[i].from * 1 && fd.get().nr_gassprings <= volume_discount[i].to * 1) {
                    gasveer_price_piece = gasveer_price_piece * (1 - volume_discount[i].amount / 100);
                    aanbouw_price_piece_rod = aanbouw_price_piece_rod * (1 - volume_discount[i].amount / 100);
                    aanbouw_price_piece_cyl = aanbouw_price_piece_cyl * (1 - volume_discount[i].amount / 100);
                    break;
                }
            }
            total_price_discounted = fd.get().nr_gassprings * gasveer_price_piece + fd.get().nr_gassprings * (aanbouw_price_piece_rod + aanbouw_price_piece_cyl);
        }
        var total_discount_percentage = Math.round(((total_price_without_discount - total_price_discounted) / total_price_without_discount) * 100 * 10) / 10;

        total_price_discounted = Math.round(total_price_discounted * 100) / 100;
        if (total_price_discounted !== total_price_without_discount) {
            text_html = '<s class="price old">' + this.format_price(total_price_without_discount) + '</s> <span class="discount-percentage">-' + total_discount_percentage + '%</span> <span class="price new">= ' + this.format_price(total_price_discounted) + '</span>';
        } else {
            text_html = '<span class="price">' + this.format_price(total_price_without_discount) + '</span>';
        }

        $('#fl_total_price').html(text_html);
    }

    format_price(price) {
        var currencySymbol = price_format["currencySymbol"];
        var decimalSeparator = price_format["decimalSeparator"];
        var thousandSeparator = price_format["thousandSeparator"];
        var decimals = price_format["decimals"] > 2 ? 2 : price_format["decimals"];
        var currencyPosition = price_format["currencyPosition"];

        // Round the price to the required number of decimals using JavaScript's toFixed
        let roundedPrice = Number(price).toFixed(decimals);

        // Split the rounded price into the whole part and decimal part based on the dot separator (since JS uses the dot as default)
        let parts = roundedPrice.split('.');

        // Whole part before the decimal
        let whole = parts[0];

        // Decimal part after the dot
        let decimal = parts.length > 1 ? parts[1] : '';

        // Add thousand separators to the whole part
        whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

        // Combine the whole part and the decimal part using the desired decimal separator
        let formattedPrice = whole;
        if (decimals > 0) {
            formattedPrice += decimalSeparator + decimal;
        }

        // Add the currency symbol in the correct position
        switch (currencyPosition) {
            case 'left':
                return currencySymbol + formattedPrice;
            case 'left_space':
                return currencySymbol + '&nbsp;' + formattedPrice;
            case 'right':
                return formattedPrice + currencySymbol;
            case 'right_space':
                return formattedPrice + '&nbsp;' + currencySymbol;
            default:
                return formattedPrice;
        }
    }

    get_gs_description(gs) {
        var a = [];
        a.push(gs.type);
        a.push(gs.stangdia);
        a.push(gs.huisdia);
        a.push(gs.slag);
        a.push(gs.lengte);
        a.push(gs.materiaal);
        return a.join('_');
    }

    set_configurator_description() {
        if (!this.plot_3d.fl_2d.mouse_is_down) {
            var title;
            if (fd.get().units === 'Metric') {
                title = this.gs.title + ". " + texts.force + " " + this.gs.min_force + "N - " + this.gs.max_force + "N. " + texts.thread + " M" + this.gs.dschroefdraad + ".";
            } else {
                title = this.gs.title + ". " + texts.force + " " + this.gs.min_force + "N (" + newton_to_lbs(this.gs.min_force) + " lbs.) - " + this.gs.max_force + "N (" + newton_to_lbs(this.gs.max_force) + " lbs.). " + texts.thread + " M" + this.gs.dschroefdraad + ".";
            }
            $("#canvas_title").html(title);
        }
    }

    set_mounting_part_images(target_name, target_value) {
        // in case whe have something like 'schroefoog-bevestigingsplaat', we only want  'schroefoog'
        var target_value_set = target_value.split('-')[0] || target_value;

        let imagePath = '../wp-content/plugins/fl_gasspring_configurator/assets/dist/img/' + target_value_set + '.jpg';

        if (target_name.startsWith("mp_cyl")) {
            $('.cf-mp.cf-mp-left.js-cf-mp').css('background-image', 'url("' + imagePath + '")');
        } else {
            $('.cf-mp.cf-mp-right.js-cf-mp').css('background-image', 'url("' + imagePath + '")');
        }

        // if none is chosen then the center line needs to shift
        this.check_background_images();
    }

    rearrangeSquares(selectedSquare, containerId) {
        const container = document.getElementById(containerId);
        const squares = Array.from(container.children);
        const selectedSquareIndex = squares.indexOf(selectedSquare);

        // Remove the selected square from the array
        squares.splice(selectedSquareIndex, 1);

        // Insert the selected square at the beginning of the array
        squares.unshift(selectedSquare);

        // Clear the container
        container.innerHTML = '';

        // Append squares back to the container in the new order
        squares.forEach(square => container.appendChild(square));
    }

    // Set the right mounting part as selected in the mounting part chooser dialog
    set_mounting_part_dialog_image_selected(target_name, target_value) {
        let selectorPrefix, containerId;
        let selectedClass, selectedContainerClass;
        var target_value_set = target_value.split('-')[0] || target_value;

        if (target_name.startsWith("mp_cyl")) {
            selectorPrefix = "mp-cyl-";
            containerId = "mp-container-cyl";
            selectedClass = 'mp-selected-cyl';
            selectedContainerClass = '.mp-square-cyl';
        } else {
            selectorPrefix = "mp-rod-";
            containerId = "mp-container-rod";
            selectedClass = 'mp-selected-rod';
            selectedContainerClass = '.mp-square-rod';
        }

        const squareId = selectorPrefix + target_value_set;
        const square = document.getElementById(squareId);

        // Remove selected class from all relevant squares
        document.querySelectorAll(selectedContainerClass).forEach(s => s.classList.remove(selectedClass));

        if (square) {
            // Add selected class to the current square
            square.classList.add(selectedClass);

            // Rearrange squares
            this.rearrangeSquares(square, containerId);
        }
    }


    check_background_images() {
        // check for no mounting parts and change the center lines accordingly
        // Select the target nodes
        var leftNode = document.querySelector('.cf-mp.cf-mp-left.js-cf-mp');
        var rightNode = document.querySelector('.cf-mp.cf-mp-right.js-cf-mp');

        // Options for the observer (which mutations to observe)
        var config = {attributes: true, attributeFilter: ['style']};

        var leftBackgroundImage = this.getBackgroundImage(leftNode);
        var rightBackgroundImage = this.getBackgroundImage(rightNode);

        // first reset all
        $('.cf-selector-width-no-mp-both').removeClass('cf-selector-width-no-mp-both').addClass('cf-selector-width');
        $('.cf-selector-width-no-mp-left').removeClass('cf-selector-width-no-mp-left').addClass('cf-selector-width');
        $('.cf-selector-width-no-mp-right').removeClass('cf-selector-width-no-mp-right').addClass('cf-selector-width');

        if (leftBackgroundImage.includes('none.jpg') && rightBackgroundImage.includes('none.jpg')) {
            $('.cf-selector-width').removeClass('cf-selector-width').addClass('cf-selector-width-no-mp-both');
        } else if (leftBackgroundImage.includes('none.jpg')) {
            $('.cf-selector-width').removeClass('cf-selector-width').addClass('cf-selector-width-no-mp-left');
        } else if (rightBackgroundImage.includes('none.jpg')) {
            $('.cf-selector-width').removeClass('cf-selector-width').addClass('cf-selector-width-no-mp-right');
        }
    }

    // Function to get the background image of an element
    getBackgroundImage(element) {
        var computedStyle = window.getComputedStyle(element);
        return computedStyle.getPropertyValue('background-image');
    }

    // function to store the last step button that was clicked in the cookie
    setCookieStepButtonClick(buttonId) {
        document.getElementById('step_visited').value = buttonId;
        var ck = new cookie();
        ck.set();
    }

    // to handle the buttons which show/hide certain parts of the page
    async handle_step_button(stepId, storeCookie = true) {
        var self = this;
        switch(stepId) {
            case 'step-1':
                // // back_to_1_btn was clicked - from step 4 to 1
                // $("#step-2").slideUp();
                // $("#step-1").slideDown();

                if (!self.initiating) {
                    // $("html, body").animate({
                    //     scrollTop: $("#step-1").offset().bottom
                    // }, "fast");
                }

                $("#step-2").addClass('hidden');
                $("#step-3").addClass('hidden');
                $("#step-4").addClass('hidden');
                $("#buttons-step-2-and-3").addClass('hidden');
                $("#step-1").removeClass('hidden');

                break;

            case 'step-2':
                // show_best_matching_gas_spring_btn or back_to_2_btn was clicked - from step 1 to 2
                // $("#step-2").slideDown();
                // $('#step-1').slideUp();

                $("#step-2").removeClass('hidden');
                $("#buttons-step-2-and-3").removeClass('hidden');
                $("#step-1").addClass('hidden');
                $("#step-4").addClass('hidden');
                $("#buttons-step-2-and-3").removeClass('hidden');

                // flip buttons
                $("#refine_gas_spring_btn").show();
                $("#refine_gas_spring_btn_2").hide();
                $("#add_to_cart_btn").show();
                $("#add_to_cart_btn_2").hide();

                // 36 pixels is the height of the blue navigation bar
                if (!self.initiating) {
                    // $("html, body").animate({
                    //     scrollTop: $("#step-2").offset().top - 70
                    // }, "fast");
                }

                // the refine option needs to be shown directly
                $("#step-3").removeClass('hidden');
                $("#step-2").removeClass('hidden');
                $("#step-4").addClass('hidden');
                $("#buttons-step-2-and-3").removeClass('hidden');

                // flip buttons
                $("#refine_gas_spring_btn_2").show();
                $("#refine_gas_spring_btn").hide();
                $("#add_to_cart_btn_2").show();
                $("#add_to_cart_btn").hide();

                $("#step-1").addClass('hidden');
                break;

            case 'step-3':
                //refine_gas_spring_btn was clicked - from step 2 to 3 show refine section
                $("#step-3").removeClass('hidden');
                $("#step-2").removeClass('hidden');
                $("#step-4").addClass('hidden');
                $("#buttons-step-2-and-3").removeClass('hidden');

                // flip buttons
                $("#refine_gas_spring_btn_2").show();
                $("#refine_gas_spring_btn").hide();
                $("#add_to_cart_btn_2").show();
                $("#add_to_cart_btn").hide();

                $("#step-1").addClass('hidden');

                break;

            case 'back-to-step-2':
                // refine_gas_spring_btn_2 was clicked - from step 3 to 2 hide refine section
                // $("#step-2").slideDown();
                // $('#step-1').slideUp();

                // $("#step-3").addClass('hidden');
                // $("#buttons-step-2-and-3").removeClass('hidden');

                // flip buttons
                $("#refine_gas_spring_btn").show();
                $("#refine_gas_spring_btn_2").hide();
                $("#add_to_cart_btn").show();
                $("#add_to_cart_btn_2").hide();

                break;

            case 'step-4-skip-3':
                // add_to_cart_btn was clicked - from step 2 to 4
                $("#step-4").removeClass('hidden');
                $("#step-2").removeClass('hidden');

                $("#step-1").addClass('hidden');
                $("#buttons-step-2-and-3").removeClass('hidden');
                $("#refine_gas_spring_btn_2").hide();
                $("#add_to_cart_btn_2").hide();

                break;

            case 'step-4':
                // add_to_cart_btn_2 was clicked - from step 3 to 4
                $("#step-4").removeClass('hidden');
                $("#step-3").addClass('hidden');
                $("#step-2").removeClass('hidden');

                $("#step-1").addClass('hidden');
                $("#buttons-step-2-and-3").removeClass('hidden');

                //flip buttons
                $("#refine_gas_spring_btn").show();
                $("#refine_gas_spring_btn_2").hide();
                $("#add_to_cart_btn").show();
                $("#add_to_cart_btn_2").hide();

                break;

            default: //go to 1st step
                // $("#step-2").slideUp();
                // $("#step-1").slideDown();

                if (!self.initiating) {
                    // $("html, body").animate({
                    //     scrollTop: $("#step-1").offset().top - 36
                    // }, "fast");
                }

                $("#step-2").addClass('hidden');
                $("#step-3").addClass('hidden');
                $("#step-4").addClass('hidden');
                $("#buttons-step-2-and-3").addClass('hidden');
                $("#step-1").removeClass('hidden');

        }

        if(storeCookie) {
            //store button step in cookie
            this.setCookieStepButtonClick(stepId);
        }
    }

    // Function to update button text based on current index
    updateButtonText(currentGasSpringIndex) {
        var prevButton = document.getElementById('length_combi_index_down');
        var nextButton = document.getElementById('length_combi_index_up');
        var prevButtonInnerText = prevButton.innerText;
        var nextButtonInnerText = nextButton.innerText;

        prevButton.innerText = prevButtonInnerText.replace(/\(\d+\/\d+\)/, "(" + (currentGasSpringIndex + 1) + "/20)");
        nextButton.innerText = nextButtonInnerText.replace(/\(\d+\/\d+\)/, "(" + (currentGasSpringIndex + 2) + "/20)");
    }

    set_listeners() {
        var self = this;

        $('#length_combi_index_down').click(async function () {
            if (!self.as.auto_select && self.as.length_combi_index >= 1) {
                self.as.length_combi_index -= 1;
                await self.as.set_length_combi();
                self.update();
                // self.updateButtonText(self.as.length_combi_index);
            }
        });

        $('#length_combi_index_up').click(async function () {
            if (!self.as.auto_select && self.as.length_combi_index < self.as.sorted_length_combis.length) {
                self.as.length_combi_index += 1;
                await self.as.set_length_combi();
                self.update();
                self.updateButtonText(self.as.length_combi_index);
            }
        });

        $('#gasspring_total_length_imperial').change(function () {
            self.sync_imperial_to_metric(false);
            self.cookie.set();
        });

        $('#gasspring_total_length').change(function () {
            self.cookie.set();
        });

        $('#gasspring_wished_force_imperial').change(function () {
            self.sync_imperial_to_metric(false);
            self.cookie.set();
        });

        $('#gasspring_wished_force').change(function () {
            self.cookie.set();
        });

        $('input[name="mp_cyl_type"]').change(function () {
            self.set_mounting_part_images(this.name, this.value);
            self.cookie.set();
        });

        $('input[name="mp_rod_type"]').change(function () {
            self.set_mounting_part_images(this.name, this.value);
            self.cookie.set();
        });

        $('input[name="nr_gassprings"]').change(function () {
            self.cookie.set();
        });

        $('select[name="force"]').change(function () {
            self.cookie.set();
            $('input[name="gasspring_wished_force"]').val($(this).val());
            self.update(false);
        });

        $('#confirm-button').on('click', function() {
            $('#alarm-modal').hide(); // Close the modal when the user confirms
        });

        /* configurator page is divided in 4 steps
        * step 1. Choose mounting parts, force, material and type of gas spring
        * step 2. Show the 2d plot and let the customer choose to refine or directly jump to add to cart step
        * step 3. Redefine the gas spring, different mounting parts (thread/eye diameter), different gas spring
        * step 4. Add to cart, choose the amount and add to cart
        */

        //from step 1 to step 2, show rendering
        $("#show_best_matching_gas_spring_btn").click(async function () {
            self.as.auto_select = true;

            if (self.plot_3d) {
                self.plot_3d.start_animation_on_2d_plot = true;
                await self.update(false);

                var stepId = "step-2";
                self.handle_step_button(stepId);

                self.plot_3d.plot_configuration_2d();


            }
        });

        //from step 2 to step 3, show options to refine gas spring
        $("#refine_gas_spring_btn").click(async function () {
            var stepId = "step-3";
            self.handle_step_button(stepId);
        });

        //from step 3 to step 2, hide options to refine gas spring
        $("#refine_gas_spring_btn_2").click(async function () {
            var stepId = "back-to-step-2";
            // self.handle_step_button(stepId);
        });

        //from step 2 to step 4 (skip refine), select amount and add to cart
        $("#add_to_cart_btn").click(function() {
            // var stepId = "step-4-skip-3";
            var stepId = "step-4";
            // self.handle_step_button(stepId);
        });

        //from step 3 to step 4, select amount and add to cart
        $("#add_to_cart_btn_2").click(function() {
            var stepId = "step-4";
            self.handle_step_button(stepId);
        });

        //from step 2 to 1
        $("#back_to_1_btn").click(function(){
            var stepId = "step-1";
            self.handle_step_button(stepId);
        });

        //from step 3 to 1
        $("#back_to_1_btn_2").click(function(){
            var stepId = "step-1";
            self.handle_step_button(stepId);
        });

        $('#material').change(function () {
            self.change_material();
            self.cookie.set();
        });

        $('#type').change(function () {
            self.change_type();
            self.change_material();
            self.cookie.set();
        });

        $('#thread').change(function () {
            self.update();
        });

        $('#mp_cyl').change(function () {
            self.update();
        });

        $('#mp_rod').change(function () {
            self.update();
        });

        $('#gasspring').change(function () {
            self.change_gasspring(true);
        });

        $('#units').change(function () {
            self.change_gasspring(true);

            if($('#units').val() === 'Metric') {
                //switching from imperial to metric
                self.sync_imperial_to_metric(true);
            } else {
                //switching from metric to imperial
                self.sync_metric_to_imperial(true);
            }

            self.cookie.set();
        });

        $('#force').change(function () {
            self.update(false);
        });

        $('#fl_configurator_add_to_cart').click(function () {
            self.set_alarms()
            self.add_to_cart();
        });

        $('#nr_gassprings').on('input change keyup', function () {

            let value = parseInt($(this).val());

            // Restrict value to be between 1 and 100000
            if (value < 1) {
                $(this).val(1);
            } else if (value > 100000) {
                $(this).val(100000);
            }

            self.set_price_text();
        });

        var show_2d_cad = $('.show_2d_cad');
        if (show_2d_cad.length) {
            show_2d_cad.click(function (event) {
                var product = self[$(this).data('what')];
                self.show_2d_dialog(product);
            });
        }

        $('button.form-button.view_2d').click(function () {
            var view = $(this).data("what");
            self.plot_3d.set_view_2d(view);
        });

        document.querySelectorAll('.mp-square-cyl').forEach(square => {
            square.addEventListener('click', () => {
                document.querySelectorAll('.mp-square-cyl').forEach(s => s.classList.remove('mp-selected-cyl'));
                square.classList.add('mp-selected-cyl');
                self.rearrangeSquares(square, 'mp-container-cyl');
            });
        });

        document.querySelectorAll('.mp-square-rod').forEach(square => {
            square.addEventListener('click', () => {
                document.querySelectorAll('.mp-square-rod').forEach(s => s.classList.remove('mp-selected-rod'));
                square.classList.add('mp-selected-rod');
                self.rearrangeSquares(square, 'mp-container-rod');
            });
        });

        let hidePopupTimeout;

        $(document).on('click touchstart', '.show_2d_cad_dd', (event) => {
            event.stopPropagation(); // Stops all other click handlers from firing

            const element = event.currentTarget;
            const data = $(element).data('cadpic').split(',');

            const cadpic = data[0];
            const side = data[1];
            $('#popup-2d-cad-image').attr('src', cadpic);

            const maxPopupSize = 600;
            const viewportWidth = $(window).width();
            const viewportHeight = $(window).height();

            const popupWidth = Math.min(maxPopupSize, viewportWidth - 20);
            const popupHeight = Math.min(maxPopupSize, viewportHeight - 100);

            // Get current scroll position to account for scroll
            const scrollTop = $(window).scrollTop();
            const scrollLeft = $(window).scrollLeft();

            // Center the popup horizontally and vertically
            let left = (viewportWidth - popupWidth) / 2 + scrollLeft;
            let top = (viewportHeight - popupHeight) / 2 + scrollTop;

            // Set the CSS for the popup and show it
            $('#popup-2d-cad').css({
                top: top + 'px',
                left: left + 'px',
                width: popupWidth + 'px',
                height: popupHeight + 'px',
                'text-align': 'center',
                'display': 'flex',
                'justify-content': 'center',
                'align-items': 'center'
            }).show();

            // Adjust the image size to fit the popup
            $('#popup-2d-cad-image').css({
                width: (popupWidth - 20) + 'px',
                height: (popupHeight - 20) + 'px',
                'object-fit': 'contain'
            });

            clearTimeout(hidePopupTimeout);

        });

// Close the popup with a delay when the mouse moves outside its boundaries
        $('#popup-2d-cad').on('mouseleave touchend', () => {
            hidePopupTimeout = setTimeout(() => {
                $('#popup-2d-cad').hide();
            }, 500);  // Delay of 500ms before hiding the popup
        });

// Cancel hiding if the mouse re-enters the popup before the delay
        $('#popup-2d-cad').on('mouseenter', () => {
            clearTimeout(hidePopupTimeout);
        });

// Close the popup when clicking outside of it
        $(document).on('click', (event) => {
            if (!$(event.target).closest('#popup-2d-cad').length) {
                $('#popup-2d-cad').hide();
            }
        });

// Close the popup when clicking directly on it
        $('#popup-2d-cad').on('click', () => {
            $('#popup-2d-cad').hide();
        });
    }

    show_2d_dialog(product, self) {
        // console.log(product);
        if (product.type === "gasveer" || product.type === "gastrekveer") {
            if (product.png !== '') {
                this.show_gs_png_dialog(product.png);
            } else if (product.pdf !== '') {
                this.show_gs_pdf_dialog(product.pdf);
            }
        } else {
            this.show_mp_png_dialog(product.cad_array);
        }
    }

    show_gs_png_dialog(png_url) {
        var img = new Image();
        img.onload = function() {

            const d = new dialog('<div id="container_2d" style="width: fit-content; height: fit-content;"></div>', 0, 0);
            d.open();

            var imgElement = $('<img class="cad_img_2d">');
            imgElement.attr('src', png_url);
            imgElement.appendTo('#container_2d');
        };
        img.src = png_url;
    }

    show_gs_pdf_dialog(pdf_url) {
        let pdf_size_w = '100vw';
        let pdf_size_h = '100vh';
        const d = new dialog('<div id="container_2d" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"></div>', pdf_size_w, pdf_size_h);
        d.open();
        var iframe = $('<iframe class="cad_iframe_2d">');
        iframe.attr('src', pdf_url);
        iframe.css('width', '100vw');
        iframe.css('height', '100vh');
        iframe.appendTo('#container_2d');
    }

    show_mp_png_dialog(cad_array) {
        if (cad_array.length > 0) {
            let maxImgWidth = 0;
            let maxImgHeight = 0;

            let loadedImages = 0;

            cad_array.forEach((cad_url, index) => {
                var img = new Image();
                img.onload = () => {
                    if (img.width > maxImgWidth) maxImgWidth = img.width;
                    if (img.height > maxImgHeight) maxImgHeight = img.height;

                    loadedImages++;
                    if (loadedImages === cad_array.length) {
                        const { width, height } = this.calculateMaxDimensions(maxImgWidth, maxImgHeight);
                        const d = new dialog('<div id="container_2d" style="display: flex; justify-content: center; align-items: center; width: fit-content; height: fit-content;"></div>', 0, 0);
                        d.open();

                        for (let cad_url of cad_array) {
                            var imgElement = $('<img class="cad_img_2d">');
                            imgElement.attr('src', cad_url);
                            imgElement.appendTo('#container_2d');
                        }

                        let images = $('#container_2d .cad_img_2d');
                        if (images.length === 1) {
                            images.css('max-width', '100%');
                        } else if (images.length === 2) {
                            images.css('max-width', '50%');
                        }
                    }
                };
                img.src = cad_url;
            });
        }
    }

    show_mp_cad_png_popup() {
        if (product.cad_array.length > 0) {
            let maxImgWidth = 0;
            let maxImgHeight = 0;

            let loadedImages = 0;

            cad_array.forEach((cad_url, index) => {
                var img = new Image();
                img.onload = () => {
                    if (img.width > maxImgWidth) maxImgWidth = img.width;
                    if (img.height > maxImgHeight) maxImgHeight = img.height;

                    loadedImages++;
                    if (loadedImages === cad_array.length) {
                        const { width, height } = this.calculateMaxDimensions(maxImgWidth, maxImgHeight);
                        const d = new dialog('<div id="container_2d" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"></div>', width, height);
                        d.open();

                        for (let cad_url of cad_array) {
                            var imgElement = $('<img class="cad_img_2d">');
                            imgElement.attr('src', cad_url);
                            imgElement.appendTo('#container_2d');
                        }
                    }
                };
                img.src = cad_url;
            });
        }
    }

    calculateMaxDimensions(maxImgWidth, maxImgHeight) {
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;

        const imgAspectRatio = maxImgWidth / maxImgHeight;
        const viewportAspectRatio = viewportWidth / viewportHeight;

        let size_x, size_y;

        if (imgAspectRatio > viewportAspectRatio) {
            size_x = viewportWidth;
            size_y = viewportWidth / imgAspectRatio;
        } else {
            size_y = viewportHeight;
            size_x = viewportHeight * imgAspectRatio;
        }

        return { width: size_x, height: size_y };
    }

}

$(document).ready(async function () {
    /*
    Only start the configurator elements when the configurator form is present.
    The file /assets/dist/js/configurator.min.js is also used externally for
    plotting purposes. This, for example, in the single product pages of gas springs
    and mounting parts. This is programmed in featherlight-core/src/WooCommerceFunctions.
     */
    if ($("#cf-form").length) {
        // $(".section-selector").hide();
        // $(".configurator-section.refine").hide();
        // $(".buttons-step-2-and-3-section").hide();


        fd = new form_data('cf-form');
        mp_data_store = new data(mp_data);
        gs_data_store = new data(gs_data);

        cf = new configurator();
        await cf.init();
        help = new help();

        $(".cf_loader").removeClass("loader_non_transparent").addClass("loader_transparent");
        $("#featherlight-configurator").removeClass("step-2");
        // $(".section-selector").show();
        // $(".configurator-section.refine").show();
        // $(".buttons-step-2-and-3-section").show();
    }

});
